import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateClassificationMutation as CreateClassificationMutationType,
  CreateClassificationMutationVariables,
} from "./__generated__/CreateClassificationMutation";

const CreateClassificationMutation = loader("./CreateClassificationMutation.gql");

type CreateClassificationMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateClassificationMutationType) => void;
}) => ReactElement;

export const CreateClassificationMutationProvider: CreateClassificationMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateClassificationMutationType, CreateClassificationMutationVariables>(
    CreateClassificationMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
